import { testimonials } from "@/mocks/guaData";

export default function About() {
  return (
    <section id="about" className="py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-8 rounded-2xl border border-background-200 bg-gradient-to-br from-background-50 to-accent-50 p-6 md:p-10 lg:grid-cols-[1fr_1fr]">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="inline-block h-4 w-1 rounded-full bg-primary-500"></span>
              关于每日有瓜
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              把散落各处的瓜，变成每天都能围观的热闹
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              每日有瓜诞生的初衷很简单：热点太多、瓜太多，常常不知道该从哪里看起。于是我们把「大家怎么看」「正在热议什么」实时聚到一起——讨论区有人抛话题，评论区有人接梗，吃瓜现场永远热热闹闹。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-600">
              我们相信，好的讨论应该轻松、友善、就事论事。这里不鼓励带节奏，更不纵容造谣与人身攻击，希望大家都能舒服地吃瓜、尽兴地聊天。
            </p>
            <div className="mt-5 flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-600">
              <i className="ri-mail-send-line text-primary-500"></i>
              商务与投稿联系：hello@meiriyougua.com
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-2">
            {[
              { icon: "ri-fire-line", n: "24.8万+", l: "每日围观吃瓜群众" },
              { icon: "ri-chat-3-line", n: "326", l: "实时热议现场" },
              { icon: "ri-group-line", n: "58万+", l: "累计注册讨论用户" },
              { icon: "ri-time-line", n: "99%", l: "当日话题准点更新" },
            ].map((s) => (
              <div key={s.l} className="rounded-xl border border-background-200 bg-background-50 p-5 text-center">
                <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <p className="mt-3 font-display text-2xl text-primary-600">{s.n}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.l}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10">
          <div className="text-center">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950">老瓜友的口碑</h2>
            <p className="mt-2 text-sm text-foreground-600">他们每天准时来蹲最新的一口瓜</p>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl border border-background-200 bg-background-50 p-5">
                <div className="flex text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">{t.name[0]}</span>
                  <div className="leading-tight">
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}